<template>
    <p-form ref="form">
        <div v-if="product">
            <p-card title="">
                <b-row>
                    <p-feature-flag name="Product Images">
                        <b-col cols="12" lg="auto">
                            <b-row>
                                <b-col style="padding:10px 15px">
                                    <p-image
                                        ref="generalImage"
                                        v-model="
                                            productFamily.onlineProfileProperties
                                                .images[0]
                                        "
                                        @newURL="newPrimaryURL"
                                    />
                                </b-col>
                            </b-row>
                            <b-row style="padding:0 15px">
                                <b-col
                                    style="padding:0 5px 0 0"
                                    v-for="index in [1, 2, 3]"
                                    :key="index"
                                >
                                    <p-image
                                        :ref='"image" + index'
                                        v-model="
                                            productFamily
                                                .onlineProfileProperties.images[
                                                index
                                            ]
                                        "
                                        @newURL="e => ImageURL(index, e)"
                                        small
                                    />
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <div v-if="product && (product.gmVariant1 || product.gmVariant2 || product.sku)">
                                        <div class="variant-info">
                                            <strong>Selected Variant</strong>
                                            <div>
                                                <span>SKU: </span>
                                                <strong>{{ product.sku }}</strong>
                                            </div>
                                            <div v-if="product.gmVariant1">
                                                <span>{{ this.productFamily.gmVariantGroup1Name || 'Size' }}: </span> 
                                                <strong>{{ product.gmVariant1 }}</strong>
                                            </div>
                                            <div v-if="product.gmVariant2">
                                                <span>{{ this.productFamily.gmVariantGroup2Name || 'Color' }}: </span> 
                                                <strong>{{ product.gmVariant2 }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                    </p-feature-flag>

                    <b-col>
                        <b-row>
                            <b-col cols="12" lg="8">
                                <p-input
                                    label="Product Description"
                                    v-model="productFamily.description"
                                    rules="required|max:200"
                                    @change="SetDefaultValuesForOnlineProfile()"
                                />
                            </b-col>
                            <b-col cols="12" lg="4">
                                <p-select
                                    label="Product Type"
                                    :options="productTypes"
                                    :model-value="determineProductType"
                                    text-field="text"
                                    :disabled="!isNew"
                                    rules="required"
                                />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" sm="6" xl="2">
                                <p-number
                                    input-type="money"
                                    name="Cost"
                                    label="Cost"
                                    v-model.number="productInventory.cost"
                                    rules="required|min_value:0"
                                    @change="calculateMargin()"
                                    left-align
                                    :disabled="determineProductType === PRODUCT_TYPE.PACKAGE"
                                >
                                    <template v-slot:append>
                                        <p-button
                                            type="button"
                                            @click="showAccountingCostUpdater(productInventory)"
                                        >
                                            <i class="fas fa-redo fa-fw"></i>
                                        </p-button>
                                    </template>
                                </p-number>
                            </b-col>
                            <b-col cols="12" sm="6" xl="2">
                                <p-number
                                    input-type="percent"
                                    disabled="disabled"
                                    label="Margin"
                                    v-model.number="productInventory.margin"
                                    left-align
                                >
                                </p-number>
                            </b-col>
                            <b-col cols="12" sm="6" xl="2">
                                <p-number
                                    label="Selling Price"
                                    v-model="productInventory.sellingPrice"
                                    rules="required|min_value:0"
                                    input-type="money"
                                    @change="calculateMargin()"
                                    left-align
                                >
                                    <template v-slot:append>
                                        <p-button
                                            type="button"
                                            @click="showCalculator(productInventory)">
                                            <i class="fas fa-calculator"></i>
                                        </p-button>
                                    </template>
                                </p-number>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <p-advanced-select
                                    label="DCC"
                                    data-type="dcc"
                                    @change="dccChanged"
                                    v-model.number="product.dccId"
                                    :filter="dccFilter"
                                    rules="required"
                                />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" lg="6">
                                <p-advanced-select
                                    label="Brand"
                                    data-type="brands"
                                    v-model="productFamily.productBrandId"
                                    add-empty-option
                                >
                                    <template v-slot:append>
                                        <b-button
                                            class="ms-0 px-1"
                                            style="white-space:nowrap;"
                                            v-b-modal.addBrand
                                            >Add New</b-button
                                        >
                                    </template>
                                </p-advanced-select>
                            </b-col>

                            <b-col cols="9" sm="4" xl="4">
                                <p-select
                                    data-type="priceTagTypes"
                                    label="Tag Type"
                                    v-model="product.priceTagTypeId"
                                    :filter="1"
                                />
                            </b-col>
                            <b-col
                                cols="3"
                                sm="2"
                                xl="2"
                                style="margin-top:40px"
                            >
                                <p-feature-flag name="Barcode Print">
                                    <b-button
                                            type="button"
                                            class=" px-2"
                                            style="white-space:nowrap;"
                                             variant="outline-primary"
                                             @click="showPrintLabel"
                                            > Print Label
                                    </b-button >
                                    <PrintLabel
                                        v-if="product.priceTagTypeId && product.defaultBarcode && product.productInventories[0].productInventoryId > 0"
                                        :product-family="productFamily"
                                        :product="product"
                                        :products="products"
                                        ref="printLabelButton"
                                    />
                                </p-feature-flag>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" lg="6">
                                <p-input
                                    label="Product Notes"
                                    v-model="productFamily.comment"
                                    rules="max:200"
                                />
                            </b-col>

                            <b-col cols="12" lg="6">
                                <p-input
                                    label="Default Supplier"
                                    disabled="disabled"
                                    rules="max:200"
                                    :model-value="defaultSupplier"
                                >
                                </p-input>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" lg="4">
                                <p-advanced-select
                                    v-if="!productFamily.isMatrix"
                                    label="Size"
                                    name="productDetailSize"
                                    data-type="productVariants"
                                    :filter="'1'"
                                    v-model="product.gmVariant1Id"
                                    add-empty-option
                                >
                                    <template v-slot:append>
                                        <b-button
                                            class="ms-0 px-1"
                                            style="white-space:nowrap;"
                                            v-b-modal.addSize
                                            >Add New</b-button
                                        >
                                    </template>
                                </p-advanced-select>
                                <p-advanced-select
                                    v-else
                                    label="Variant Group 1"
                                    data-type="productVariantGroups"
                                    v-model="productFamily.gmVariantGroup1Id"
                                    disabled
                                >
                                </p-advanced-select>
                            </b-col>
                            <b-col cols="12" lg="4">
                                <p-advanced-select
                                    v-if="!productFamily.isMatrix"
                                    label="Color"
                                    name="productDetailColor"
                                    data-type="productVariants"
                                    v-model="product.gmVariant2Id"
                                    :filter="'2'"
                                    add-empty-option
                                >
                                    <template v-slot:append>
                                        <b-button
                                            class="ms-0 px-1"
                                            style="white-space:nowrap;"
                                            v-b-modal.addColor
                                            >Add New</b-button
                                        >
                                    </template>
                                </p-advanced-select>
                                <p-advanced-select
                                    v-else
                                    label="Variant Group 2"
                                    data-type="productVariantGroups"
                                    v-model="productFamily.gmVariantGroup2Id"
                                    disabled
                                >
                                </p-advanced-select>
                            </b-col>
                            <b-col cols="12" lg="4" v-if="!productFamily.isMatrix">
                                <p-feature-flag ref="serializationFlag" name="Serialization">
                                    <p-card title="Serialize" style="margin-top: 15px;">
                                        <div class="d-flex flex-wrap align-items-center gap-1">
                                            <p-checkbox
                                                :label="productFamily.isSerializationActive ? 'Enabled' : 'Disabled'"
                                                :use-switch="true"
                                                v-model="productFamily.isSerializationActive"
                                                size="sm"
                                                @change="serializationToggleChange()"
                                            >
                                            </p-checkbox>
                                            <div @click="depEligibleToggleChange()">
                                                <p-checkbox
                                                    label="DEP Eligible"
                                                    :use-switch="true"
                                                    v-model="productFamily.isDepEligible"
                                                    :disabled="!productFamily.isSerializationActive"
                                                    size="sm"
                                                >
                                                </p-checkbox>
                                            </div>
                                            <b-button
                                                class="px-2"
                                                variant="outline-primary"
                                                :disabled="!productFamily.isSerializationActive"
                                                @click="manageButtonClick()"
                                            >Manage Serials</b-button>
                                        </div>  
                                    </p-card>                                  
                                </p-feature-flag>
                            </b-col>                            
                        </b-row>
                    </b-col>
                </b-row>
            </p-card>

            <p-card title="SKU(s)">
                <b-button
                        class=" py-2 btn-add-variant ms-3"
                        v-if="productFamily.isMatrix"
                        style="white-space:nowrap;"
                            variant="outline-primary"                
                            @click="showAddVariantsModal()"
                        > <i class="pe-2 fas fa-edit"></i>Add Variants 
                </b-button >
                <div class="sku-cell-inputs">
                <p-table
                    ref="SKUTable"
                    :items="products"
                    :fields="fieldsSKU"
                    :enableRowSelection="false"
                    :per-page="500"
                    class="wide mt-2"
                    outlined
                    :row-class="(item, type) => type === 'row' && item && String(item.sku) === String(product.sku) ? 'b-table-row-selected table-active' : ''"
                >
                    <template #thead-top="data">
                        <b-tr class="text-center">
                        <b-th colspan="8"></b-th>
                        <b-th colspan="2" class="custom-border-left" >Current Location</b-th>
                        <b-th colspan="2" class="custom-border-left custom-border-right">All Locations</b-th>
                        </b-tr>
                    </template>
                    <template
                        v-slot:cell(productImageId)="{
                            value,
                            item
                        }"
                    >
                        <p-image
                            :ref='"image" + item.sku'
                            v-model="
                                item.productImage
                            "
                            @newURL="e => SKUImageURL(item, e)"
                            small
                            :key="item.sku"
                        />
                    </template>

                    <template
                        v-slot:cell(defaultBarcode)="{
                            value,
                            item
                        }"
                    >
                        <p-input
                            label=""
                            name="Default Barcode"
                            v-model="item.defaultBarcode"
                            :disabled="true"
                            class="pt-3"
                        >
                            <template v-slot:append>
                                <p-button @click="openBarcodes(item)">
                                    More
                                </p-button>
                            </template>
                        </p-input>
                    </template>
                    <template
                        v-slot:cell(sellingPrice)="{
                            value,
                            item
                        }"
                    >
                        <p-number
                            input-type="money"
                            name="Selling Price"
                            label=""
                            rules="min_value:0"
                            v-model.number="item.productInventories[0].sellingPrice"
                            left-align
                            class="pt-3"
                        >
                            <template v-slot:append>
                                <p-button
                                    type="button"
                                    @click="showCalculator(item.productInventories[0])">
                                    <i class="fas fa-calculator"></i>
                                </p-button>
                            </template>
                        </p-number>
                    </template>
                    <template
                        v-slot:cell(eventPrice)="{
                            value,
                            item
                        }"
                    >
                        <p-number
                            label=""
                            name="Event Price"
                            :model-value="getEventPrice(item.productInventories[0])"
                            disabled="disabled"
                            input-type="money"
                            left-align
                            class="pt-3"
                        >
                            <template v-slot:append>
                                <b-button
                                    @click="openSalesEvent(item)"
                                    v-if="$featureFlagEnabled('Sales Events')"
                                >
                                View
                                </b-button>
                            </template>
                        </p-number>
                    </template>
                     
                    <template
                        v-slot:cell(lastSold)="{
                            value,
                            item
                        }"
                    >
                        <span> 
                            <span v-if="item.productInventories[0].lastSold">
                            {{
                                dateFormatter(
                                    item.productInventories[0].lastSold
                                )
                            }}
                            {{
                                datetimeToLocalTimeOnlyFormatter(
                                    item.productInventories[0].lastSold
                                )
                            }}
                            </span>
                            <span v-else>N/A</span>
                        </span>
                        
                    </template>
                    <template
                        v-slot:cell(stockOnHand)="{
                            value,
                            item
                        }"
                    >
                        <p-number
                            label=""
                            name="Stock On Hand"
                            v-model="item.productInventories[0].stockOnHand"
                            disabled="disabled"
                            input-type="integer"
                            left-align
                            class="pt-3"
                        >
                            <template v-slot:append>
                                <p-button type="button" @click="showSOHModal(item.productInventories[0], item.productInventoryLocations)">
                                    Edit
                                </p-button>
                            </template>
                        </p-number>
                    </template>
                    <template
                        v-slot:cell(onOrder)="{
                            value,
                            item
                        }"
                    >
                        <div>{{integerFormatter(item.productInventories[0].onOrder)}}</div>
                    </template>
                    <template
                        v-slot:cell(totalStockOnHand)="{
                            value,
                            item
                        }"
                    >
                        <span
                            class="clickable-values"
                            @click="showAllLocationsDetails(item)"
                            >{{   integerFormatter(item.productInventories[0].totalStockOnHand , "N/A")}}</span
                        >
                    </template>
                    <template
                        v-slot:cell(totalOnOrder)="{
                            value,
                            item
                        }"
                    >
                        <span
                            class="clickable-values"
                            @click="showAllLocationsDetails(item)"
                            >{{ integerFormatter(item.productInventories[0].totalOnOrder , "N/A") }}</span
                        >
                    </template>
                    <template
                        v-slot:cell(isActive)="{
                            value,
                            item
                        }"
                    >
                        <div class="status-toggle-wrapper d-flex flex-column align-items-center">
                            <p-checkbox
                                inline
                                :use-switch="true"
                                v-model="item.isActive"
                            >
                            </p-checkbox>
                            <div>{{ item.isActive ? 'Active' : 'Inactive' }}</div>
                        </div>
                    </template>
                </p-table>
                </div>
                <p-modal
                    size="lg"
                    name="addVariants"
                    label="Manage Variants"
                    no-close-on-backdrop
                >
                    <template v-slot:default>
                        <p-card>
                            <b-row>
                                <b-col cols="6" sm="6">
                                    <p-advanced-select
                                        label=""
                                        data-type="productVariantGroups"
                                        v-model="productFamily.gmVariantGroup1Id"
                                        disabled
                                    >
                                    </p-advanced-select>
                                </b-col>
                                <b-col cols="6" sm="6">
                                    <p-advanced-select
                                        label=""
                                        data-type="productVariantGroups"
                                        v-model="productFamily.gmVariantGroup2Id"
                                        disabled
                                    >
                                    </p-advanced-select>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="6" sm="6">
                                    <p-table
                                        ref="VariantTable1"
                                        :items="variants1"
                                        :fields="fieldsVariants"
                                        :per-page="200"
                                        class="wide"
                                        outlined
                                        :is-selected-function="item => item.isCheckedVarient || isExistingVariant(item)"
                                        @toggle-selection="item => !isExistingVariant(item) && (item.isCheckedVarient = !item.isCheckedVarient)"
                                        :disable-row-check="isExistingVariant"
                                        select-all-label="Toggle All"
                                    >
                                    </p-table>
                                </b-col>
                                <b-col cols="6" sm="6">
                                    <p-table
                                        ref="VariantTable2"
                                        :items="variants2"
                                        :fields="fieldsVariants"
                                        :per-page="200"
                                        class="wide"
                                        outlined
                                        :is-selected-function="item => item.isCheckedVarient || isExistingVariant2(item)"
                                        @toggle-selection="item => !isExistingVariant2(item) && (item.isCheckedVarient = !item.isCheckedVarient)"
                                        :disable-row-check="isExistingVariant2"
                                        select-all-label="Toggle All"
                                    >
                                    </p-table>
                                </b-col>                         
                            </b-row>
                        </p-card>
                </template>
                <template v-slot:modal-footer>
                    <b-row>
                        <b-col>
                            <p-button
                                variant="outline-primary"
                                @click="$bvModal.hide('addVariants')"
                                class="me-2"
                                >Cancel</p-button
                            >
                            <p-button
                                variant="primary"
                                @click="handleGenerateSKU"
                                :disabled="calculatedSKUCount<=0"
                                class="float-end"
                                >Generate ({{ calculatedSKUCount }})
                                SKU{{ calculatedSKUCount > 1 ? 's' : '' }}</p-button
                            >
                        </b-col>
                    </b-row>
                </template>
                </p-modal>
            </p-card>
            <p-card v-if="determineProductType === PRODUCT_TYPE.PACKAGE" class="mt-3">
                <b-row>
                    <b-col cols="12">
                        <h4>Package Components</h4>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <p-form inline>
                            <ProductMultiSelectQuickSearch
                                is-active-filter
                                label="Add Component(s)"
                                icon-plus
                                name="packageComponentSearch"
                                @selections="addComponentsToPackage"
                                search-destination="addcomponenttopackagesearch"
                                fieldSet="addComponentToPackageFields"
                                :remove-filter-options="[
                                    'Author',
                                    'Title',
                                    'Catalog #',
                                    'ISBN',                                            
                                    'Supplier',
                                    'Barcode',
                                    'Book Key'
                                ]"
                                :per-page="perPageAddComponentToPackage"
                                @per-page-change="e => { perPageAddComponentToPackage = e }"
                            />
                        </p-form>
                    </b-col>
                </b-row>                
                <b-row class="mt-2">
                    <b-col cols="12">
                        <p-form inline class="w-100">
                            <p-table
                                class="w-100"
                                :items="productFamily.packageComponents"
                                :fields="packageComponentFields"
                                :enable-row-selection="false"
                                ref="packageComponents"
                                :selectable="false"
                                sort-by="description"
                                searchDestination="null">
                                    <!-- Add the editable Qty field for adding product(s) to packages -->
                                    <template #cell(qty)="slotData">
                                        <p-input
                                            v-model="slotData.item.qty"
                                            size="sm"
                                            @change="e => onPackageQtyChange(slotData.item, e)"
                                            style="max-width: 55px;"
                                            rules="required|integer|min_value:0"
                                            name="Qty"
                                            class="text-center"
                                        />
                                    </template>
                                    <template #cell(deleteProduct)="slotData">
                                        <b-button type="button" class="p-1 ms-1 short-button" @click="deletePackageComponent(slotData.item)">
                                            <BIconTrash icon="trash"></BIconTrash>
                                        </b-button>
                                    </template>
                            </p-table>
                        </p-form>
                    </b-col>
                </b-row>  
            </p-card>
            <p-card>
                <b-row>
                    <b-col>
                        <h4>Online Profile</h4>
                    </b-col>
                    <b-col cols="auto" class="ms-auto me-2">
                        <p-checkbox
                            label="Publish Active SKUs Online?"
                            :use-switch="true"
                            v-model="
                                productFamily.onlineProfileProperties
                                    .isPublishOnline
                            "
                            size="lg"
                        >
                        </p-checkbox>
                    </b-col>
                </b-row>
                <b-row class="mt-1">
                    <b-col cols="12" lg="4" xl="4">
                        <p-input
                            label="Website Display Name"
                            name="shortDescriptionEditor"
                            v-model="
                                productFamily.onlineProfileProperties
                                    .shortDescription
                            "
                            rules="max:200"
                        />
                    </b-col>
                    <b-col cols="12" lg="3" xl="3">
                        <p-number
                            label="Default Inventory Tolerance"
                            input-type="integer"
                            name="onlineInventoryTolerance"
                            v-model="
                                productFamily.onlineProfileProperties
                                    .inventoryTolerance
                            "
                        >
                        </p-number>
                    </b-col>

                    <b-col cols="12" lg="3" xl="3">
                        <p-number
                            input-type="money"
                            v-model="
                                productFamily.onlineProfileProperties
                                    .shippingFee
                            "
                            @focus="
                                initialShippingFee =
                                    productFamily.onlineProfileProperties
                                        .shippingFee
                            "
                            rules="min_value:0"
                            name="onlineShippingOverride"
                            label="Shipping Override"
                            left-align
                        />
                    </b-col>
                </b-row>
                <b-row class="mt-3 pb-3" cols="12" cols-sm="12" cols-xl="12">
                    <b-col cols="12" lg="12">
                        <label>
                            Long Description
                            <p-button
                                v-if="$featureFlagEnabled('Product AI')"
                                variant="outline-primary"
                                size="sm"
                                @click="showAskAiModal"
                                class="ms-2"
                            >
                                <i class="fas fa-robot me-1"></i> Ask AI
                            </p-button>
                        </label>
                        <div style="max-height: 300px; overflow-y: auto;">
                            <custom-quill-editor toolbar="full" placeholder="Insert text here..." v-model:content='productFamily.onlineProfileProperties.longDescription' content-type="html" />
                        </div>
                    </b-col>
                </b-row>
            </p-card>

            <p-card>
                <b-row>
                    <b-col cols="12" lg="12" xl="2">
                        <h4>Web Catalogs</h4>
                    </b-col>
                    <b-col cols="12" lg="12" xl="2">
                        <p-checkbox
                            v-model="filterSelected"
                            size="md"
                            label="Show Only Selected"
                        ></p-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <p-table
                            :items="getItems"
                            :fields="fieldsCatalog"
                            :disable-row-check="
                                data => {
                                    return (
                                        data.status.toLocaleLowerCase() ==
                                        'closed'
                                    );
                                }
                            "
                            :is-selected-function="isSelected"
                            @toggle-selection="toggleCatalog"
                            :per-page="20"
                            class="wide"
                        >
                        </p-table>
                    </b-col>
                </b-row>
            </p-card>

            <p-modal
                name="addBrand"
                label="Add Brand"
                size="md"
                no-close-on-backdrop
                no-close-esc
                @shown="showModal"
                ref="addBrandModal"
            >
                <template v-slot:default>
                    <p-form ref="form">
                        <div>
                            <b-row>
                                <b-col>
                                    <p-input
                                        label="Brand Name"
                                        vid="brandName"
                                        v-model="brandName"
                                        rules="required|max:50"
                                        ref="setFocus"
                                    />
                                </b-col>
                            </b-row>
                        </div>
                    </p-form>
                </template>

                <template v-slot:modal-footer>
                    <b-row>
                        <b-col class=" mb-3 text-center">
                            <p-button
                                :is-busy="addingBrandIsBusy"
                                variant="outline-primary"
                                @click="handleAddBrand"
                                >OK</p-button
                            >
                        </b-col>
                    </b-row>
                </template>
            </p-modal>
            <PriceCalculator
                :initial-values="getInventory"
                :parameters="parameters"
                :disableCost="determineProductType === PRODUCT_TYPE.PACKAGE"
                @apply="applyPricing">
            </PriceCalculator>
            <AccountingCostUpdater
                :initial-values="getInventory"
                :parameters="parameters"
                @ok="saveAccountingCost"
                :is-package="determineProductType === PRODUCT_TYPE.PACKAGE"
            ></AccountingCostUpdater>
            <p-modal
                name="addSize"
                label="Add New Size"
                size="md"
                no-close-on-backdrop
                no-close-esc
                ok-only
                @ok.prevent="handleAddSize"
                @shown="showAddSizeModal"
                @hidden="resetAddSizeModal"
                ref="addSizeModal"
            >
                <template v-slot:default>
                    <p-form ref="addSizeForm">
                        <div>
                            <b-row>
                                <b-col>
                                    <p-input
                                        label="Size Name"
                                        vid="SizeDescription"
                                        v-model="sizeDescription"
                                        rules="required|max:80"
                                        :validate-on-model-update="false"
                                        ref="setFocus"
                                    />
                                </b-col>
                            </b-row>
                        </div>
                    </p-form>
                </template>
            </p-modal>
            <p-modal
                name="addColor"
                label="Add New Color"
                size="md"
                no-close-on-backdrop
                no-close-esc
                ok-only
                @ok.prevent="handleAddColor"
                @shown="showAddColorModal"
                @hidden="resetAddColorModal"
                ref="addColorModal"
            >
                <template v-slot:default>
                    <p-form ref="addColorForm">
                        <div>
                            <b-row>
                                <b-col>
                                    <p-input
                                        label="Color Name"
                                        vid="ColorDescription"
                                        v-model="colorDescription"
                                        rules="required|max:80"
                                        :validate-on-model-update="false"
                                        ref="setFocus"
                                    />
                                </b-col>
                            </b-row>
                        </div>
                    </p-form>
                </template>
            </p-modal>
            <p-modal
                name="allLocationsDetails"
                label="SKU Stock on Hand & On Order at All Locations"
                size="xl"
                no-close-on-backdrop
                no-close-esc
                ref="allLocationsDetailsModal"
            >
            <template v-slot:modal-title>
                 <h3>SKU Stock on Hand & On Order at All Locations  <small>({{productItem?.defaultBarcode != null ? `${productItem.defaultBarcode}`: ''}}{{productItem?.gmVariant1 != null ? `, ${productItem.gmVariant1}` :''}}{{productItem?.gmVariant2 != null ? `, ${productItem.gmVariant2}` :''}}) </small></h3>
            </template>
                <template v-slot:default>
                    <p-form ref="form">
                        <div>
                            <b-row>
                                <b-col>
                                    <p-table
                                        ref="locationsTable"
                                        :items="allLocationOptions"
                                        :fields="fieldsLocation"
                                        :enableRowSelection="false"
                                        :per-page="500"
                                        class="wide table-striped "
                                    >
                                        <template v-slot:cell(name)="{ value,  item }" >
                                            <div>
                                                {{item.name}} {{addressFormatter(item.address) != ""  ? `(`+addressFormatter(item.address)+`)` : ''}}
                                            </div>
                                        </template>
                                  </p-table>
                                </b-col>
                            </b-row>
                        </div>
                    </p-form>
                </template> 
                <template v-slot:modal-footer="{  cancel }">
                    <b-row class="w-100">
                        <b-col class="mb-3 text-center">
                            <p-button
                                variant="outline-primary"
                                @click="cancel"
                                class="ms-2"
                            >
                                Close
                            </p-button>
                        </b-col>
                    </b-row>
                </template>
            </p-modal>
            <BarcodeListModal
                :currentVariant="currentVariant"
                @ok="saveBarcode"
            ></BarcodeListModal>
            <StockAdjustment
                :adjustmentData="stockAdjustment"
                @ok="stockAdjustmentSucceeded"
            />
            <SalesEventModal
                :productInventory="getInventory"
                :eventPrice="getEventPriceModal"
            ></SalesEventModal>
            
            <!-- AI Description Generator Modal -->
            <p-modal
                name="askAiModal"
                label="Ask AI Long Description Generator"
                size="xl"
                no-close-on-backdrop
                ref="askAiModal"
                modal-class="ask-ai-modal">
                <template v-slot:default>
                    <p-form>
                        <div>
                            <b-row>
                                <b-col>
                                    <p-text-area
                                        label="User Request"
                                        v-model="aiPrompt"
                                        rows="4"
                                        placeholder="Edit this prompt to refine the AI response..." />
                                </b-col>
                            </b-row>
                            <b-row class="mt-2">
                                <b-col>
                                    <div class="d-flex align-items-center">
                                        <p-button
                                            variant="primary"
                                            @click="generateAiDescription"
                                            :is-busy="aiGeneratingDescription"
                                        >
                                            <i class="fas fa-magic me-1"></i> Generate Description
                                        </p-button>
                                        <span class="text-muted ms-3" style="font-size: 0.95em;">
                                            AI responses may take up to one minute or even longer depending on the prompt.
                                        </span>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="mt-3">
                                <b-col>
                                    <label class="mb-1">Description</label>
                                    <custom-quill-editor
                                        toolbar="full"
                                        content-type="html"
                                        v-model:content="aiResponse.generatedDescriptionHtml" />
                                </b-col>
                            </b-row>
                        </div>
                    </p-form>
                </template>

                <template v-slot:modal-footer>
                    <b-row class="w-100">
                        <b-col class="d-flex justify-content-end">
                            <p-button
                                variant="outline-secondary"
                                @click="closeAskAiModal"
                                class="me-2">
                                Cancel
                            </p-button>
                            <p-button
                                variant="success"
                                @click="useAiDescription"
                                :disabled="!aiResponse">
                                <i class="fas fa-check me-1"></i> Use Description
                            </p-button>
                        </b-col>
                    </b-row>
                </template>
            </p-modal>
        </div>
    </p-form>
</template>

<script>
import axios from 'axios';
import StockAdjustment from '@/components/StockAdjustment.vue';
import BarcodeListModal from './../BarcodeListModal';
import PrintLabel from './../PrintLabelGM.vue';
import pricing from '@/services/PricingCalculations.js';
import PriceCalculator from '../PriceCalculator.vue';
import AccountingCostUpdater from '../AccountingCostUpdater.vue';
import PCard from '../../../components/p-card.vue';
import 'quill/dist/quill.snow.css';
import SalesEventModal from './SalesEventModal.vue';
import StoreListManager from '@/components/mixins/StoreListManager.js';
import {integerFormatter } from "../../../components/Common/Formatters.js";
import selectListOptionsDataContext from '@/services/selectListOptions.dataContext.js';
import { addressFormatter, dateFormatter, datetimeToLocalTimeOnlyFormatter, currencyFormatter } from '@/components/Common/Formatters.js';
import ProductMultiSelectQuickSearch from '@/components/ProductMultiSelectQuickSearch.vue';
import { PRODUCT_TYPE_VALUE, PRODUCT_TYPE } from '@/components/Common/Constants.js';

export default {
    mixins: [StoreListManager],
    props: {
        parameters: Object,
        product: Object,
        products: Array,
        isNew: Boolean,
        productFamily: Object,
        productInventory: Object
    },
    data() {
        return {
            selectListOptions: {
                webCatalogs: [],
                states: []
            },
            productItem: null,
            isLoading: false,
            filterSelected: false,
            currentVariant: { barcodes: [], defaultBarcode: null },
            salesEvent: {},
            perPageAddComponentToPackage: 10,
            aiPrompt: '',
            aiResponse: {
                generatedDescriptionHtml: ''
            },
            aiGeneratingDescription: false,
            productTypes: [
                { value: PRODUCT_TYPE.COMMON, text: PRODUCT_TYPE.COMMON },
                { value: PRODUCT_TYPE.MATRIX, text: PRODUCT_TYPE.MATRIX },
                { value: PRODUCT_TYPE.PACKAGE, text: PRODUCT_TYPE.PACKAGE }
            ],
            brandName: '',
            brands: [],
            defaultSupplier: '',
            expectedMargin: 0,
            stockAdjustment: {},
            sizeDescription: '',
            colorDescription: '',
            defaultEventPrice: null,
            formIsDirty: false,
            addingBrandIsBusy: false,
            productVariantDetails: {
                productVariantId: null,
                productVariantTypeId: null,
                variantName: '',
                status: '',
                productVariantGroupings: []
            },
            fieldsCatalog: [
                {
                    key: 'text',
                    label: 'Name',
                    sortable: true
                },
                {
                    key: 'description',
                    label: 'Description'
                },
                {
                    key: 'groups',
                    label: 'Catalog Group(s)'
                },
                {
                    key: 'status',
                    label: 'Status'
                }
            ],
            fieldsSKU: [
                {
                    key: 'productImageId',
                    label: ''
                },
                {
                    key: 'sku',
                    label: 'SKU'
                },
                {
                    key: 'gmVariant1',
                    label: 'Variant 1',
                    sortable: true,
                    // Sort by the variant's configured sort order rather than its text; variants with
                    // no saved sort order sink to the bottom. Zero-padded so the sort compares
                    // numerically (otherwise "10" would sort before "2"). Display still shows the value.
                    sortByFormatted: (value, key, item) => String(item.gmVariant1SortOrder ?? Number.MAX_SAFE_INTEGER).padStart(10, '0')
                },
                {
                    key: 'gmVariant2',
                    label: 'Variant 2',
                    sortable: true,
                    sortByFormatted: (value, key, item) => String(item.gmVariant2SortOrder ?? Number.MAX_SAFE_INTEGER).padStart(10, '0')
                },
                {
                    key: 'gmVariant1Id',
                    label: '',
                    hidden:true
                },
                {
                    key: 'gmVariant2Id',
                    label: '',
                    hidden:true
                },
                {
                    key: 'defaultBarcode',
                    label: 'Default Barcode'
                },
                {
                    key: 'sellingPrice',
                    label: 'Selling Price'
                },
                {
                    key: 'eventPrice',
                    label: 'Event Price'
                },
                {
                    key:'lastSold',
                    label:'Last Sold',
                    thClass: 'last-sold',
                    tdClass: 'last-sold'
                },
                {
                    key: 'stockOnHand',
                    label: 'Stock on Hand',
                    thClass: 'text-center custom-border-left',
                    tdClass: 'text-center custom-border-left'
                },
                {
                    key: 'onOrder',
                    label: 'On Order',
                    thClass: 'text-center custom-border-right',
                    tdClass: 'text-center custom-border-right'
                },
                {
                    key: 'totalStockOnHand',
                    label: 'Stock on Hand',
                    thClass: 'text-center',
                    tdClass: 'text-center' 
                },
                {
                    key: 'totalOnOrder',
                    label: 'On Order',
                    thClass: 'text-center custom-border-right',
                    tdClass: 'text-center custom-border-right'
                },
                {
                    key: 'isActive',
                    label: 'Status',
                    thClass: 'text-center',
                    tdClass: 'text-center'
                }
            ],
            fieldsLocation: [
                {
                    key: 'name',
                    label: 'Location',
                    tdClass:'location-width' 
                },
                {
                    key: 'stockOnHand',
                    label: 'Stock on Hand (SOH)',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                    formatter: (value) => integerFormatter(value, "-")
                },
                {
                    key: 'onOrder',
                    label: 'On Order',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                    formatter: (value) => integerFormatter(value, "-")
                }
            ],
            fieldsVariants: [
                {
                    key: 'name',
                    label: ''
                }
            ],
            packageComponentFields: [
                {
                    key: 'qty',
                    label: 'Qty'
                },                
                {
                    key: 'sku',
                     label: 'SKU',
                    sortable: true
                },
                {
                    key: 'authorTitleOrDescription',
                    label: 'Description',
                    sortable: true
                },
                {
                    key: 'gmVariant1',
                    label: 'Variant 1'
                },
                {
                    key: 'gmVariant2',
                    label: 'Variant 2'
                },
                {
                    key: 'stockOnHand',
                    label: 'SOH',
                    sortable: true
                },
                {
                    key: 'retail',
                    sortable: true,
                    formatter: currencyFormatter
                },
                {
                    key: 'cost',
                    sortable: true,
                    formatter: currencyFormatter
                },
                {
                    key: 'accountingCost',
                    sortable: true,
                    formatter: value => value == null ? '' : currencyFormatter(value)
                },
                {
                    key: 'deleteProduct',
                    label: ''
                },                
            ],            
            SKUInventory:{
            },
            calculatorProductInventory: null,
            SKUEventPrice:null,
            currentIndex:0,
            allLocationOptions:[],
            variants1:[{
                         isCheckedVarient:false
                        }],
            variants2:[{
                        isCheckedVarient:false
                     }],
            existingVariants1: [],
            existingVariants2:[],
            emptyProduct:{
                sku	:	null,
                priceTagTypeId	:	null,
                dccId	:	0,
                gmVariant1	:	null,
                gmVariant2	:	null,
                barcodes:[],
                defaultBarcode	:	null,
                isActive	:	true,
                productInventories:[{
                    productInventoryId	:	0,
                    sku	:	null,
                    locationId	:	0,
                    stockOnHand	:	null,
                    isEventPercentage	:	null,
                    lastSaleDate	:	null,
                    sellingPrice	:	0,
                    eventPrice	:	null,
                    lastsold: null,
                    eventStartDate	:	null,
                    eventEndDate	:	null,
                    onOrder	:	0,
                    cost	:	0,
                    accountingCost	:	null,
                    margin	:	0,
                    retail	:	0,
                    minStock	:	null,
                    maxStock	:	null,
                    newSellingPrice	:	null,
                    newSellingPriceStartDate	:	null,
                    totalStockOnHand	:	null,
                    totalOnOrder	:	0
                }],
                gmVariant1Id	:	null,
                gmVariant2Id	:	null,
                gmVariantGroup1Id	:	null,
                gmVariantGroup2Id	:	null,
                productImage	:	null
            }
        };
    },
    computed: {
        calculatedSKUCount() {
            if(this.variants2.length==0){
               return this.variants1.filter(x => x.isCheckedVarient===true).length;
           }else{
               return  ((this.variants1.filter(x => x.isCheckedVarient===true).length)
                          *
                (this.variants2.filter(x => x.isCheckedVarient===true)
                          .length+this.existingVariants2.length))
                          +
                (this.variants2.filter(x => x.isCheckedVarient===true)
                          .length * this.existingVariants1.length);
           }
        },
        getInventory(){
            return this.SKUInventory;
        },
        getEventPriceModal(){
            return this.SKUEventPrice;
        },
        getItems() {
            return this.filterSelected
                ? this.selectListOptions.webCatalogs.filter(
                      x => this.isSelected(x)
                  )
                : this.selectListOptions.webCatalogs;
        },
        getDefaultSupplier() {
            let isEmpty =
                this.productFamily.suppliersProperties === null ||
                this.productFamily.suppliersProperties.filter(
                    x => x.isDefault === true
                ).length === 0;
            return isEmpty
                ? ''
                : this.productFamily.suppliersProperties.filter(
                      x => x.isDefault === true
                  )[0].vendorName;
        },
        newSellingPriceStartDateRules() {
            return this.product.newSellingPrice ? 'required' : '';
        },
        discountAmountValidationRules() {
            if (this.productInventory.isEventPercentage == null)
                return 'min_value:0.01|max_value:100';

            return this.productInventory.isEventPercentage
                ? 'required|min_value:0.01|max_value:100'
                : 'required|min_value:.01|max_value:' +
                      this.productInventory.sellingPrice;
        },

        eventStartDateRule() {
            return this.formIsDirty
                ? this.productInventory.eventPrice != null &&
                  this.productInventory.eventPrice != 0
                    ? 'required|dateLessThanOrEqual:@eventPriceEndDate'
                    : 'dateLessThanOrEqual:@eventPriceEndDate'
                : '';
        },
        eventEndDateRule() {
            return this.formIsDirty
                ? this.productInventory.eventPrice != null &&
                  this.productInventory.eventPrice != 0
                    ? 'required|dateGreaterOrEqual:@eventPriceStartDate'
                    : 'dateGreaterOrEqual:@eventPriceStartDate'
                : '';
        },
        getEventStartDate() {
            var date = new Date();
            date.setDate(date.getDate() + 1);

            if (!this.productInventory.eventStartDate) return date;

            var eventStartDate = new Date(this.productInventory.eventStartDate);

            if (eventStartDate < date) {
                date = eventStartDate;
            }

            return date;
        },
        getEventEndDate() {
            var date = new Date();
            date.setDate(date.getDate() + 1);

            if (!this.productInventory.eventEndDate) return date;

            var eventEndDate = new Date(this.productInventory.eventEndDate);

            if (eventEndDate < date) {
                date = eventEndDate;
            }

            return date;
        },
        primaryURL() {
            return this.productFamily.imageUrl
                ? this.productFamily.imageUrl
                : '/img/no-img.png';
        },
        determineProductType: function() {
            if (this.productFamily?.productType === PRODUCT_TYPE_VALUE.PACKAGE) 
                return PRODUCT_TYPE.PACKAGE;

            return this.productFamily?.isMatrix ? PRODUCT_TYPE.MATRIX : PRODUCT_TYPE.COMMON;
        },
        // These expose the constants to the template without having to do "this." everywhere
        PRODUCT_TYPE() { return PRODUCT_TYPE; },
        PRODUCT_TYPE_VALUE() { return PRODUCT_TYPE_VALUE; },
    },
    methods: {
        handleGenerateSKU: async function() {
            if (!(await this.$refs.form.validate())) {
                return;
            }
            this.emptyProduct.productInventories[0].locationId = await selectListOptionsDataContext.getSelectedLocationIdAsync();
             this.$bvModal
                .msgBoxConfirm(
                    `Product updates will create ${this.calculatedSKUCount} new SKUs.`
                )
                .then(value => {
                    if (value) {                        
                        this.emptyProduct.productInventories[0].sellingPrice = this.productInventory.sellingPrice;
                        this.emptyProduct.productInventories[0].cost = this.productInventory.cost;
                        this.emptyProduct.productInventories[0].margin = this.productInventory.margin;

                    let newVariants1 = JSON.parse(JSON.stringify(this.variants1.filter(x => x.isCheckedVarient===true)));
                    let oldVariants1 = JSON.parse(JSON.stringify(this.variants1.filter(x => this.existingVariants1.some(y => y == x.name))));
                    let newVariants2 = JSON.parse(JSON.stringify(this.variants2.filter(x => x.isCheckedVarient===true)));
                    let oldVariants2 = JSON.parse(JSON.stringify(this.variants2.filter(x => this.existingVariants2.some(y => y == x.name))));
                    let updatedProductFamily = JSON.parse(
                            JSON.stringify(this.productFamily));
                        if(this.variants2.length==0){
                            for(let i = 0; i < newVariants1.length; i++){
                                
                                updatedProductFamily.products.push(
                                            this.emptyProduct
                                        );
                                    updatedProductFamily.products[
                                            updatedProductFamily.products.length - 1
                                        ] = {
                                            ...updatedProductFamily.products[
                                                updatedProductFamily.products.length - 1
                                            ],
                                            gmVariant1Id: newVariants1[i].productVariantId,
                                            gmVariant2Id: null
                                        };
                            }
                        }else{
                            for(let i = 0; i < newVariants1.length; i++){
                                for (let j = 0; j < oldVariants2.length; j++) {
                                    updatedProductFamily.products.push(
                                            this.emptyProduct
                                        );
                                    updatedProductFamily.products[
                                            updatedProductFamily.products.length - 1
                                        ] = {
                                            ...updatedProductFamily.products[
                                                updatedProductFamily.products.length - 1
                                            ],
                                            gmVariant1Id: newVariants1[i].productVariantId,
                                            gmVariant2Id: oldVariants2[j].productVariantId
                                        };
                                }
                                for (let j = 0; j < newVariants2.length; j++) {
                                    updatedProductFamily.products.push(
                                            this.emptyProduct
                                        );
                                    updatedProductFamily.products[
                                            updatedProductFamily.products.length - 1
                                        ] = {
                                            ...updatedProductFamily.products[
                                                updatedProductFamily.products.length - 1
                                            ],
                                            gmVariant1Id: newVariants1[i].productVariantId,
                                            gmVariant2Id: newVariants2[j].productVariantId
                                        };
                                }
                            }
                            for(let i = 0; i < newVariants2.length; i++){
                                for (let j = 0; j < oldVariants1.length; j++) {                       
                                    updatedProductFamily.products.push(
                                            this.emptyProduct
                                        );
                                    updatedProductFamily.products[
                                            updatedProductFamily.products.length - 1
                                        ] = {
                                            ...updatedProductFamily.products[
                                                updatedProductFamily.products.length - 1
                                            ],
                                            gmVariant1Id: oldVariants1[j].productVariantId,
                                            gmVariant2Id: newVariants2[i].productVariantId
                                        };
                                }
                            }
                        }
                    
                    this.isBusy = true;
                    axios
                        .post('products/generalmerchandise', updatedProductFamily)
                        .then(() => {
                            this.$emit('refreshPage');                
                            this.loadData();
                            this.$bvModal.hide('addVariants');
                            this.$appSuccess(
                                    `Product ${updatedProductFamily.description} saved successfully.`
                                )
                        })
                        .finally(() => {
                            this.isBusy = false;
                        });
                    }
                });
        },
        isExistingVariant(item){
             return this.existingVariants1.some(x => x == item.name); 
        },
        isExistingVariant2(item){
             return this.existingVariants2.some(x => x == item.name); 
        },
        async showPrintLabel(){
            if(this.formIsDirty) {
                this.$bvModal.msgBoxOk('You must save the product before you can print label(s).')
            } else {
                this.$bvModal.show('printLabelModal');
            }
        },
        integerFormatter: integerFormatter,
        addressFormatter:addressFormatter,
        dateFormatter: dateFormatter,
        datetimeToLocalTimeOnlyFormatter: datetimeToLocalTimeOnlyFormatter,
        async showAllLocationsDetails(item){
              
           let locationId = await selectListOptionsDataContext.getSelectedLocationIdAsync();
            this.productItem = item;
            axios
                .get('products/getonhandonorder', {
                    params: { sku: item.sku, locationId: locationId }
                })
                .then(resp => {
                    this.allLocationOptions = resp.data;
                    this.$refs.allLocationsDetailsModal.show();
                });
        },
        getEventPrice(productInventory) {
            if (!productInventory?.salesEvent?.priceMod) return null;
            return pricing.computeEventPrice(productInventory.retail, productInventory.salesEvent.priceMod);
        },
        showCalculator(productInventory){
            this.SKUInventory=JSON.parse(
                JSON.stringify(productInventory));
            this.calculatorProductInventory = productInventory;
            setTimeout(() => {
                this.$bvModal.show('priceCalculator')
            },50);
        },
        showAccountingCostUpdater(productInventory) {
            this.SKUInventory = JSON.parse(
                JSON.stringify(productInventory));
            this.SKUInventory.accountingCost = this.SKUInventory.accountingCost ? this.SKUInventory.accountingCost : 0;
            setTimeout(() => {
                this.$bvModal.show('accountingCostUpdater')
            }, 50);
        },
        async showSOHModal(variant, productInventoryLocations) {
            if (variant.sellingPrice === 0) {
                await this.$bvModal
                    .msgBoxConfirm(
                        'Are you sure you want make a $0 stock adjustment?'
                    )
                    .then(value => {
                        if (value) {
                            this.openSOHModal(variant, productInventoryLocations);
                        }
                    });
            } else {
                this.openSOHModal(variant, productInventoryLocations);
            }
        },
        openSOHModal(variant, productInventoryLocations) {
            this.stockAdjustment.sku = variant.sku == 0 ? null : variant.sku;

            this.stockAdjustment.cost = variant.cost;
            this.stockAdjustment.retail = variant.sellingPrice;
            this.stockAdjustment.isPackage = this.productFamily.productType === PRODUCT_TYPE_VALUE.PACKAGE;

            selectListOptionsDataContext.getSelectedLocationIdAsync()
                .then(locationId => {
                    // The productInventory record does not yet exist for this location
                    if(!productInventoryLocations.some(x => x.sku == variant.sku && x.locationId == locationId)) {
                        this.$bvModal
                            .msgBoxConfirm(
                                `Are you sure you wish to create a new product inventory record for SKU ${variant.sku} for the currently selected location?`
                            )
                            .then(value => {
                                if (value) {
                                    this.$bvModal.show('StockAdjustmentModal');
                                }
                            });
                    }
                    else{
                        this.$bvModal.show('StockAdjustmentModal');
                    }
                });
        },
        stockAdjustmentSucceeded(data) {
            this.$emit('saveProduct');
            let product = this.products.find(x => x.sku == this.stockAdjustment.sku);
            const qty = Number(data.qty);
            product.productInventories[0].stockOnHand = Number(product.productInventories[0].stockOnHand) + qty;
            product.productInventories[0].totalStockOnHand = Number(product.productInventories[0].totalStockOnHand) + qty;

            if (data.isPackage && data.applyToPackageComponents) {
                this.productFamily.packageComponents.forEach(packageComponent => {
                    packageComponent.stockOnHand = Number(packageComponent.stockOnHand) - (Number(packageComponent.qty) * qty);
                });
            }

            this.$emit('clearDirtyFlag');
        },
        openSalesEvent(product) {
            this.salesEvent = JSON.parse(
                JSON.stringify(product.productInventories[0]));
            this.SKUInventory = JSON.parse(
                JSON.stringify(product.productInventories[0]));
            this.SKUEventPrice = this.getEventPrice(this.SKUInventory);
            setTimeout(() => {
                this.$bvModal.show('SalesEventModal')
            },50);
        },
        openBarcodes: async function(product) {
            this.currentVariant =  JSON.parse(
                JSON.stringify(product));
            this.$bvModal.show('BarcodeListModal');
        },
        saveBarcode(data) {
            let product = this.products.find(x => x.sku == this.currentVariant.sku);
            product.barcodes = data.barcodes.map(b => ({ ...b }));
            product.defaultBarcode = data.defaultBarcode;
            this.$emit('saveProduct');
        },        
        saveAccountingCost(data) {
            let product = this.products.find(x => x.sku == data.sku);
            product.productInventories[0].accountingCost = data.accountingCost;
        },
        loadData() {
            this.defaultSupplier = this.getDefaultSupplier;
            this.calculateMargin();
            this.defaultEventPrice = this.productInventory.eventPrice;
        },
        // Called by the parent (EditGM) after load/save via $refs.generalTab.
        // Clears the local dirty flag on the next tick so the deep productFamily
        // watcher (which fires during load) doesn't immediately re-set it.
        dataLoaded() {
            setTimeout(() => {
                this.formIsDirty = false;
            }, 0);
        },
        newPrimaryURL(value) {
            this.productFamily.imageUrl = value;
        },
        ImageURL(index, value) {
            if (!this.productFamily.onlineProfileProperties.images[index]) {
                this.productFamily.onlineProfileProperties.images[index] = {};
            }
            this.productFamily.onlineProfileProperties.images[index].dataURL = value;
        },
        SKUImageURL(item, value){
            let product = this.products.find(x=>x.sku==item.sku);
            if (!product.productImage) product.productImage = {};
            product.productImage.dataURL = value;
        },
        handleAddBrand(event) {
            if (!this.brandName) {
                event.preventDefault();
                return;
            }

            this.addingBrandIsBusy = true;
            axios
                .post('/brand', {
                    brandName: this.brandName
                })
                .then(resp => {
                    this.$refs.addBrandModal.hide();
                    this.productFamily.productBrandId = resp.data;
                    this.brandName = '';
                })
                .finally(() => {
                    this.addingBrandIsBusy = false;
                });
        },
        calculateMargin() {
            this.productInventory.margin = pricing.computeMargin(
                this.productInventory.cost,
                this.productInventory.sellingPrice);
        },
        calculatePackageCost() {
            const packageComponents = this.productFamily?.packageComponents || [];

            let totalCost = 0;
            let totalAccountingCost = 0;
            packageComponents.forEach(packageComponent => {
                totalCost += (packageComponent.cost || 0) * (packageComponent.qty || 0);
                totalAccountingCost += (packageComponent.accountingCost || 0) * (packageComponent.qty || 0);
            });            
            
            const cost = parseFloat(totalCost.toFixed(2));
            const accountingCost = parseFloat(totalAccountingCost.toFixed(2));

            if (this.productFamily) {
                this.productFamily.cost = cost;
            }

            if (this.productInventory) {
                this.productInventory.cost = cost;
                this.productInventory.accountingCost = accountingCost;
            }
        },
        dccChanged: async function() {
            if (!this.product?.dccId) {
                return;
            }
            this.products.forEach(product => {
                product.dccId = this.product.dccId; // Set the chosen DCC on the ProductFamily on all the Products
            });
            axios
                .get('products/dccdefaults', {
                    params: { dccId: this.product.dccId }
                })
                .then(resp => {
                    if (resp.data.margin != null) {
                        this.expectedMargin = resp.data.margin;
                        this.product.priceTagTypeId =
                            resp.data.priceTagTypeId ??
                            this.product.priceTagTypeId;
                    }
                });
        },
        refreshDefaultSupplier() {
            this.defaultSupplier = this.getDefaultSupplier;
        },
        handleAddSize: async function() {
            if (!(await this.$refs.addSizeForm.validate())) {
                return;
            }

            this.productVariantDetails.productVariantTypeId = 1;
            this.productVariantDetails.variantName = this.sizeDescription;
            this.productVariantDetails.status = 'Active';

            axios
                .post('productvariant', this.productVariantDetails)
                .then(response => {
                    this.product.gmVariant1Id = response.data;
                });

            this.$refs.addSizeModal.hide();
        },
        handleAddColor: async function() {
            if (!(await this.$refs.addColorForm.validate())) {
                return;
            }

            this.productVariantDetails.productVariantTypeId = 2;
            this.productVariantDetails.variantName = this.colorDescription;
            this.productVariantDetails.status = 'Active';

            axios
                .post('productvariant', this.productVariantDetails)
                .then(response => {
                    this.product.gmVariant2Id = response.data;
                });

            this.$refs.addColorModal.hide();
        },
        showModal() {
            this.brandName = '';
            this.sizeDescription = '';
            this.colorDescription = '';
            this.$refs.setFocus.focus();
        },
        showAddSizeModal() {
            this.$refs.setFocus?.focus();
        },
        showAddColorModal() {
            this.$refs.setFocus?.focus();
        },
        resetAddSizeModal() {
            this.sizeDescription = '';
            this.$nextTick(() => this.$refs.addSizeForm?.reset());
        },
        resetAddColorModal() {
            this.colorDescription = '';
            this.$nextTick(() => this.$refs.addColorForm?.reset());
        },
        SetDefaultValuesForOnlineProfile() {
            if (!this.productFamily.onlineProfileProperties.webPrice) {
                this.productFamily.onlineProfileProperties.webPrice = this.product.productInventories[0].sellingPrice;
            }
            if (!this.productFamily.onlineProfileProperties.shortDescription) {
                this.productFamily.onlineProfileProperties.shortDescription = this.productFamily.description;
            }
        },
        dccFilter(dcc) {
            return dcc.filter == 1;
        },
        SetEventDates() {
            if (
                this.product.eventPrice != null &&
                this.product.eventPrice != '0'
            ) {
                let today = new Date();
                today.setHours(0, 0, 0, 0);

                if (this.product.eventStartDate === null) {
                    this.product.eventStartDate = today;
                }

                if (this.product.eventEndDate == null) {
                    let tomorrow = new Date();
                    tomorrow.setDate(today.getDate() + 1);
                    tomorrow.setHours(0, 0, 0, 0);
                    this.product.eventEndDate = tomorrow;
                }

                this.formIsDirty = true;
            } else {
                this.product.eventStartDate = null;
                this.product.eventEndDate = null;
            }
        },
        clearDataEntry() {
            this.$bvModal
                .msgBoxConfirm('Are you sure you want clear the sales event?')
                .then(value => {
                    if (value) {
                        this.productInventory.isEventPercentage = null;
                        this.productInventory.eventPrice = null;
                        this.productInventory.eventStartDate = null;
                        this.productInventory.eventEndDate = null;
                        this.defaultEventPrice = null;
                    }
                });
        },
        getInputType(value) {
            return value ? 'percent' : 'money';
        },
        eventPercentageValidate() {
            this.formIsDirty = true;
            if (this.$refs.form != null) {
                this.$refs.form.validate();
            }
        },
        dateChanged() {
            this.formIsDirty = true;
        },
        isSelected(item) {
            return this.productFamily.catalogProducts.some(x => x.catalogId == item.catalogId);
        },
        toggleCatalog(item) {
            const idx = this.productFamily.catalogProducts.findIndex(x => x.catalogId == item.catalogId);
            if (idx === -1) {
                this.productFamily.catalogProducts.push({ catalogId: item.catalogId });
            } else {
                this.productFamily.catalogProducts.splice(idx, 1);
            }
        },
        showAddVariantsModal(){
            this.loadVariants1();
            this.loadVariants2();       
            this.$bvModal.show('addVariants');
        },
        async loadVariants1(){              
            axios
                .get('ProductVariantGroup', {
                    params: { id: this.productFamily.gmVariantGroup1Id }
                })
                .then(resp => {
                    this.variants1 = resp.data.productVariantGroupings
                        .filter(x => x.isActive === true)
                        .sort((a, b) => (a.sortOrder ?? Number.MAX_SAFE_INTEGER) - (b.sortOrder ?? Number.MAX_SAFE_INTEGER));
                    this.existingVariants1 = [...new Set(this.products.map(item => item.gmVariant1))];
                });
        },
        async loadVariants2(){
            if(this.productFamily.gmVariantGroup2Id == null)
            {
                this.variants2=[];
                this.existingVariants2=[];
                return;
            }              
            axios
                .get('ProductVariantGroup', {
                    params: { id: this.productFamily.gmVariantGroup2Id }
                })
                .then(resp => {
                    this.variants2 = resp.data.productVariantGroupings
                        .filter(x => x.isActive === true)
                        .sort((a, b) => (a.sortOrder ?? Number.MAX_SAFE_INTEGER) - (b.sortOrder ?? Number.MAX_SAFE_INTEGER));
                    this.existingVariants2 = [...new Set(this.products.map(item => item.gmVariant2))];
                });
        },
        serializationToggleChange(){
            if(!this.productFamily.enableSerializationToggle){
                this.$appError(
                        `Serial Numbers exist for this item, cannot disable`
                    )
                    setTimeout(() => {
                     this.productFamily.isSerializationActive = true;
                    }, 200);
                    return;
            }

            this.$nextTick(() => {                
                if(!this.productFamily.isSerializationActive) {   
                    this.productFamily.isDepEligible =  false; 
                }
            });
        },
        depEligibleToggleChange(){
            this.$nextTick(() => {                
                if(!this.productFamily.isSerializationActive) {   
                    this.$appError(
                        `The Serialized Product toggle must be Enabled to allow DEP Eligibility.`
                    )
                    setTimeout(() => {
                        this.productFamily.isDepEligible = false;
                    }, 200);
                    return;
                }
            });
        },        
        manageButtonClick(){
            this.$emit('manageButtonClick');
        },
        showAskAiModal() {
            
            // Build initial prompt with product information
            const productDescription = this.productFamily.description || '';
            const selectedBrand = this.brands?.find(b => b.value === this.productFamily.productBrandId);
            const brandName = selectedBrand ? selectedBrand.text : '';
            const longDescription = this.productFamily.onlineProfileProperties?.longDescription || '';

            // Build prompt with available information
            let promptParts = [];

            if (productDescription) {
                promptParts.push(`\nGive me a website description of ${productDescription}`);
            }            
            if (brandName) {
                promptParts.push(` by ${brandName}`);
            }
            
            this.aiPrompt = promptParts.join('').trim();
            this.aiResponse = { generatedDescriptionHtml: longDescription };
            this.$refs.askAiModal.show();
        },
        async generateAiDescription() {
            this.aiGeneratingDescription = true;
            try {
                const response = await axios.post('products/generateailongdescription', {
                    sku: this.product.sku,
                    aiPrompt: this.aiPrompt
                });
                this.aiResponse = response.data;

                if(!this.aiResponse.success)  {
                    this.$appError(this.aiResponse.error);
                    this.aiGeneratingDescription = false;
                }
            } catch (error) {
                this.$appError('Failed to generate AI description');
            } finally {
                this.aiGeneratingDescription = false;
            }
        },
        useAiDescription() {
            // Apply the AI response to the long description
            this.productFamily.onlineProfileProperties.longDescription = this.aiResponse.generatedDescriptionHtml;
            this.closeAskAiModal();
            this.$appSuccess('AI generated Long Description applied successfully');
        },
        closeAskAiModal() {
            this.$refs.askAiModal.hide();
            // Reset state without affecting dirty flag
            this.aiPrompt = '';
            this.aiResponse = { generatedDescriptionHtml: '' };
        },
        onPackageQtyChange(item, e) {
            let value = e && e.target ? e.target.value : item.qty;

            let qty = parseInt(String(value).replace(/\D/g, ''), 10);
            if (isNaN(qty))  {
                qty = 1;
            }
            else if(qty < 0) {
                qty = 0
            }

            item.qty = qty;

            this.calculatePackageCost();
            this.calculateMargin();
        },
        addComponentsToPackage(items) {
            // Add the qty field and map only the required fields
            const itemsWithQty = items.map(item => ({
                accountingCost: item.accountingCost,
                authorTitleOrDescription: item.authorTitleOrDescription,
                cost: item.cost,
                gmVariant1: item.gmVariant1,
                gmVariant2: item.gmVariant2 || item.gmVariant2,
                qty: 1,
                retail: item.retail,
                sku: item.sku,
                stockOnHand: item.stockOnHand
            }));

            this.productFamily.packageComponents = [
                ...this.productFamily.packageComponents,
                ...itemsWithQty
            ];

            this.calculatePackageCost();
            this.calculateMargin();
        },
        deletePackageComponent(component) {
            let index = this.productFamily.packageComponents.indexOf(component);
            if (index !== -1) {
                this.productFamily.packageComponents.splice(index, 1);
            }

            this.calculatePackageCost();
            this.calculateMargin();
        },
        applyPricing(pricing) {
            if (this.calculatorProductInventory) {
                this.calculatorProductInventory.cost = pricing.cost;
                this.calculatorProductInventory.sellingPrice = pricing.retail;
                this.calculatorProductInventory.margin = pricing.margin;
            }
        }          
    },
    mounted() {
        this.loadData();

        selectListOptionsDataContext.getStoreDropdownData('brands')
            .then(brands => {
                this.brands = brands;
            });
    },
    watch: {
        productFamily: {
            handler: function() {
                this.formIsDirty = true;
            },
            deep: true
        },
        $route: function(to, from) {
            if (to !== from) {
                this.loadData();
            }
        },
        'product.newSellingPrice': function(newValue, oldValue) {
            if (!oldValue) {
                var date = new Date();
                date.setDate(date.getDate() + 1);
                this.product.newSellingPriceStartDate = date;
            }
            if (!newValue) {
                this.product.newSellingPriceStartDate = null;
            }
        }
    },
    components: {
        StockAdjustment,
        BarcodeListModal,
        PrintLabel,
        PriceCalculator,
        AccountingCostUpdater,
        PCard,
        SalesEventModal,
        ProductMultiSelectQuickSearch
    }
};
</script>
<style scoped lang="scss">
@import '@/styles/app/common/variables.scss';
:deep(.location-width) {
    max-width: 300px;
}
.resizedImg :deep(.vue-dropzone ) {
    width: 50px !important;
    height: 50px !important;

    .dz-default.dz-message {
        display: none;
    }
}
.extra-padding {
    padding: 0 15px;
}
.clickable-values{
    cursor: pointer;
    color: $blue-darker;
    text-decoration: underline;
}
:deep(.table td) {
    vertical-align: middle;
}

:deep(.custom-border-left) {
    border-left:1px solid rgba(0, 0, 0, 0.12);
}

:deep(.custom-border-right) {
    border-right:1px solid rgba(0, 0, 0, 0.12);
}

.status-toggle-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.status-toggle-wrapper :deep(.d-inline-block) {
    display: block !important;
}
.status-toggle-wrapper :deep(.form-check) {
    display: flex;
    justify-content: center;
    padding-left: 3.8em;
}

:deep(.btn-add-variant) {
    display: inline-block;
}

:deep(.card-title ) {
    display: inline-block;
}
:deep(.ql-image), :deep(.ql-video) {
    display:none !important;
}
:deep(.last-sold ) {
    max-width: 90px;
}
.variant-info {
    font-size: 14px;
    color: #495057;
    display: inline-block;
    padding: 3px;
}
:deep(.highlight-sku-row ) {
    background-color: #ffeeba !important;
}

:deep(.text-center input ) {
    text-align: center;
}

.ai-response-box {
    background-color: #f8f9fa;
    min-height: 100px;
    max-height: 300px;
    overflow-y: auto;
}


</style>

<!-- Unscoped: BVN renders the input-group internals outside our scope so :deep
     selectors silently miss. Plain selectors gated by .sku-cell-inputs work
     reliably and only affect this page's SKU table. -->
<style lang="scss">
@import '@/styles/app/common/variables.scss';
.sku-cell-inputs td {
    vertical-align: middle !important;
}
.sku-cell-inputs td .pt-3 {
    padding-top: 0 !important;
}
.sku-cell-inputs td .form-group {
    margin-bottom: 0 !important;
    padding-top: 0 !important;
}
// Inputs inherit the dark border from bootstrap-reset.scss; buttons keep their
// default lighter border (matching the header-row append buttons). Align button
// height to the input so the row reads as a single unit.
.sku-cell-inputs td .input-group > .btn,
.sku-cell-inputs td .input-group > .p-button-wrapper > .btn {
    height: calc(1.5em + 0.75rem + 2px); // matches Bootstrap's .form-control default height
    padding-top: 0;
    padding-bottom: 0;
    line-height: 1;
}

/* Ask AI modal opens with the bottom input clipped — give the body ~100px
   more room so the editor fits on first paint. Width and inner scroll
   behavior are unchanged. */
.ask-ai-modal .modal-body {
    min-height: 550px;
}
</style>

